import Select from "antd/lib/select";
import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { COUNTRIES } from "../../constants/countries";

function Step2({ setCurrStep, currStep, setPayload, payload }) {
  const [country, setCountry] = useState(payload.country);
  const [language, setLanguage] = useState(payload.language);
  const countries = COUNTRIES;

  return (
    <>
      <div className="w-full mb-4">
        <label className="text-main">Country</label>
        <Select
          showSearch
          onChange={(e) => setCountry(e)}
          defaultValue={payload?.country}
          options={countries.map((itm) => {
            return {
              value: itm.name,
              label: itm.name,
            };
          })}
          className="w-full mb-4 main-input h-12 rounded-md focus:outline-none"
          size="large"
          data-testid="country_dropdown"
        />
      </div>
      <div className="w-full mb-4">
        <label className="text-main">Languages</label>
        <Select
          onChange={(e) => setLanguage(e)}
          defaultValue={payload?.language}
          options={[
            {
              value: "English",
              label: "English",
            },
            {
              value: "French",
              label: "French",
            },
            {
              value: "Latin",
              label: "Latin",
            },
          ]}
          mode="multiple"
          className="w-full mb-4 main-input h-12 rounded-md focus:outline-none"
          size="large"
          data-testid="language_dropdown"
        />
      </div>

      <div className="w-full justify-between flex fixed bottom-0 left-0 bg-white [@media(min-width:987px)]:bg-transparent p-5 [@media(min-width:987px)]:p-0 border-neutral [@media(min-width:987px)]:border-0 border-y [@media(min-width:987px)]:relative z-10 mt-10">
        {/* <button
          onClick={() => setCurrStep(currStep - 1)}
          className="bg-pri-tint border-pri bw-1 px-5 py-3 rounded-lg pri w-1/2 mr-2"
        >
          Previous
        </button> */}

        <button
          data-testid="next_button"
          onClick={() => {
            setPayload({
              country,
              language,
            });
            setCurrStep(currStep + 1);
          }}
          className="bg-pri px-5 py-3 rounded-lg text-white w-full"
        >
          Next
        </button>
      </div>
    </>
  );
}

export default Step2;
